import React from 'react'
import { Create } from 'react-admin'
import { STANDARD_PRICING_STARTUP } from 'services/cfg/form'
import UpsellingFacetSection from 'ui-shared/Facets/FacetFormSections/UpsellingFacetSection'
import UpsellingForm from 'ui-shared/Forms/UpsellingForm'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'

const LocationUpsellingCreate: React.FC = () => {
  return (
    <SectionWrapper>
      <Create record={{ pricing: STANDARD_PRICING_STARTUP }}>
        <UpsellingForm
          relatedProduct="locations"
          facetFields={<UpsellingFacetSection />}
        />
      </Create>
    </SectionWrapper>
  )
}

export default LocationUpsellingCreate
